var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPptIcon = function SvgPptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 8v32H19.83c-.286.001-.57-.06-.83-.18-.22-.1-1-6.82-1-6.82s-6.72-.78-6.82-1a1.968 1.968 0 0 1-.18-.83V8h26Z",
    fill: "#FE6C02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 32v7.82c-.22-.1-.42-.24-.59-.41l-6.82-6.82c-.17-.17-.31-.37-.41-.59H19Z",
    fill: "#FCCCC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15H17v1h1v6.5a1.5 1.5 0 0 0 1.5 1.5h4v2H22v1h4v-1h-1.5v-2h4a1.5 1.5 0 0 0 1.5-1.5V16h1v-1Zm-2 7.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V16h10v6.5ZM25 21h-1v-2h1v2Zm2 0h-1v-3.5h1V21Z",
    fill: "#fff"
  })));
};
export default SvgPptIcon;